// extracted by mini-css-extract-plugin
export default {"bx":"dashboardareachartbig_bx__r8NT7"};